import MY_VA_LINK from '../../mega-menu/constants/MY_VA_LINK';
import MY_HEALTH_LINK from '../../mega-menu/constants/MY_HEALTH_LINK';
import { withVlmLinkForUser } from './vlmLink';

/**
 * The page's mega menu data with the header's link rules applied. Rules for
 * a specific link or team belong here, so the header components stay generic.
 *
 * @param {Array} megaMenuData - mega menu data from the page
 * @param {Object} options
 * @param {boolean} options.loggedIn
 * @param {Object} options.toggles - feature toggle values
 * @param {boolean} options.useHeaderNavigation - the new header is in use
 * @returns {Array}
 */
export const buildMenuData = (
  megaMenuData,
  { loggedIn, toggles, useHeaderNavigation },
) => {
  // The new header leaves out the My VA and My HealtheVet top-level links:
  // a sixth and seventh item overflow its desktop row.
  const links =
    toggles.mhvHeaderLinks && !useHeaderNavigation
      ? [...megaMenuData, MY_VA_LINK, MY_HEALTH_LINK]
      : megaMenuData;
  return withVlmLinkForUser(links, loggedIn && !!toggles.vlmSignedInLink);
};
